//-----------------------------------------------------------------------
// GLOBAL VARIABLES 
//-----------------------------------------------------------------------
var facetExpandWidth = window.matchMedia('(min-width: 992px)'); // bootstrap 'lg' default value
var delimiter = "^";
//-----------------------------------------------------------------------
// GLOBAL FUNCTIONS
//-----------------------------------------------------------------------


var site = site || {};
site.GlobalSearch = (function () {

    var buildQuery = function (page) {
        site.Search.removeFromUrl('page');
        site.Search.removeFromUrl('sortOrder');
        site.Search.appendToUrl('page', page);
        var scopedProductCategory = $('#productSearchCategory').val();
        //var p = getFacetsFromUrl();
        var searchTerm = $('#globalSearchTextBox').val();
        if (searchTerm && searchTerm.length > 0) {
            site.Search.appendToUrl("searchTerm", searchTerm);
        }
        var sortOrder = $("#sortOrder").val();
        if (sortOrder && sortOrder.length > 0 && sortOrder != "Select") {
            site.Search.appendToUrl("sortOrder", sortOrder);
        }
        var pageSize = $("#pageSize").val();
        var result = new searchRequestObject(searchTerm, page, searchfacets(), sortOrder, scopedProductCategory, pageSize);

        return result;
    };

    function getSuggestions(searchText) {
        var query = { terms: searchText };
        $.ajax({
            method: "GET",
            url: "/products/search",
            data: $.param(query),
            contentType: "application/json",
            dataType: "json"
        })
            .done(function (data) { processSuggestionResponse(data); })
            .fail(function (data) { console.log(data) });
    }

    function processSuggestionResponse(data) {
        $('#globalSuggestionsContainer').html('');
        $('#globalSuggestionsContainer').append(data.replace(new RegExp('site.Search.autocompleteQuery', 'g'), 'site.GlobalSearch.autocompleteQuery')).show();
    }

    function removeSuggestions() {
        $('#globalSuggestionsContainer').html('').hide();
    }

    function searchRequestObject(term, page, facets, sortOrder, scopedProductCategory, pageSize) {
        this.term = term;
        this.page = page;
        this.searchfacets = facets;
        this.sortOrder = sortOrder;
        this.productSearchCategory = scopedProductCategory;
        this.pageSize = parseInt(pageSize);
    }

    function searchfacets(params) {
        var facets = {};
        $.each(params, function (fieldName, e) {
            if (fieldName != "searchTerm") {
                addFacet(facets, params, fieldName);
            }
        });

        return facets;
    }

    function addFacet(facets, params, fieldName) {
        facets[fieldName] = [];
        $.each(params[fieldName].split(delimiter), function (i, e) {
            facets[fieldName][i] = {};
            facets[fieldName][i].value = e;
            facets[fieldName][i].fieldName = fieldName;
        });
    }

    function autocompleteQuery(searchTerm) {
        $('#globalSearchTextBox').val(searchTerm);
        $('#globalSearchSubmitButton').click();
    }

    function bindGlobalSuggestionPageEvents(searchBtnId, searchTextBoxId) {
        var liSelected;

        $(searchTextBoxId).on('keyup', function (e) {
            var searchText = $(searchTextBoxId).val();
            if (searchText.length >= 3) {
                var li = $('.search-suggestion__item');
                if (e.keyCode === 38) {
                    if (liSelected) {
                        liSelected.removeClass('active');
                        next = liSelected.prev();
                        if (next.length > 0) {
                            liSelected = next.addClass('active');
                        } else {
                            liSelected = li.last().addClass('active');
                        }
                    } else {
                        liSelected = li.last().addClass('active');
                    }
                } else if (e.keyCode === 40) {
                    if (liSelected) {
                        liSelected.removeClass('active');
                        next = liSelected.next();
                        if (next.length > 0) {
                            liSelected = next.addClass('active');
                        } else {
                            liSelected = li.eq(0).addClass('active');
                        }
                    } else {
                        liSelected = li.eq(0).addClass('active');
                    }
                } else if (e.keyCode === 13) {
                    var $visuallySelectedItem = $('.search-suggestion__item.active');
                    if ($visuallySelectedItem.length > 0) {
                        $(searchTextBoxId).val($visuallySelectedItem.text());
                        $(searchBtnId).click();
                        removeSuggestions();
                    } else {
                        $(searchBtnId).click();
                        removeSuggestions();
                    }
                } else {
                    getSuggestions(searchText);
                }
            } else {
                if ((e.keyCode == 8 || e.keyCode == 46)) {
                    removeSuggestions();
                } else if (e.keyCode === 13) {
                    $(searchBtnId).click();
                }
            }
        })

        
       
        $(document).on("click", function (e) {
            var target = e.target;
            if ('.grid-search__panel:visible') {
                if (!$(target).is(searchTextBoxId) && !$(target).is('.search-suggestion__item') && !$(target).is(searchBtnId)) {
                    removeSuggestions();
                }
            }
        });
        
    }
    function bindSearchPageEvents() {
        $(document).on('click', "#globalSearchSubmitButton", function () {
            removeSelectedFacets();
            var query = buildQuery(1);
            window.location.href = '/search' + window.location.search;
        });
    };
    function removeSelectedFacets() {
        window.history.pushState("", "search", window.location.pathname.split('?')[0]);
    }
    return {
        bindGlobalSuggestionPageEvents: bindGlobalSuggestionPageEvents,
        autocompleteQuery: autocompleteQuery,
        bindSearchPageEvents: bindSearchPageEvents
    }

}());

$(document).ready(function () {
    site.GlobalSearch.bindSearchPageEvents();
    site.GlobalSearch.bindGlobalSuggestionPageEvents('#globalSearchSubmitButton', '#globalSearchTextBox');

    $('#global-search-modal').on('shown.bs.modal', function (event) {
        $('#globalSearchTextBox').val('').focus();
    });

    //remove this when search is moved back to the original design
    $('.js-search-icon').on('click', function () {
        $('#global-search-modal').modal();
    });
});